// extracted by mini-css-extract-plugin
export default {"child":"Tooltip--child--8b3cd7","container":"Tooltip--container--e7857e","arrow":"Tooltip--arrow--c6c10b"};